import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryAnnualCarbonEmissionsChart from "ApiLayer/Reports/Baseline/queryAnnualCarbonEmissionsChart";

export const useAnnualCarbonEmissionsChart = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["annualCarbonEmissionsChart", filtersetUid],
        queryFn: async () =>
            queryAnnualCarbonEmissionsChart(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
    });
};
